var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var FullScreenOverlay = /** @class */ (function (_super) {
    __extends(FullScreenOverlay, _super);
    function FullScreenOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.layerElement = null;
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }
    FullScreenOverlay.prototype.componentWillMount = function () {
        this.layerElement = document.createElement('div');
    };
    FullScreenOverlay.prototype.componentDidMount = function () {
        if (this.layerElement) {
            document.body.appendChild(this.layerElement);
            if (this.props.cancelOnEscape) {
                window.addEventListener('keydown', this.onKeyDown);
            }
            this.rerender();
        }
    };
    FullScreenOverlay.prototype.componentDidUpdate = function () {
        this.rerender();
    };
    FullScreenOverlay.prototype.componentWillUnmount = function () {
        if (this.layerElement) {
            document.body.removeChild(this.layerElement);
            if (this.props.cancelOnEscape) {
                window.removeEventListener('keydown', this.onKeyDown);
            }
        }
    };
    FullScreenOverlay.prototype.onKeyDown = function (event) {
        if ((event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) {
            this.props.onClick && this.props.onClick();
        }
    };
    FullScreenOverlay.prototype.rerender = function () {
        if (this.layerElement) {
            React.cloneElement(React.createElement("div", __assign({}, this.props), this.props.children), this.layerElement);
        }
    };
    FullScreenOverlay.prototype.render = function () {
        return React.createElement("span", { className: "FullScreenOverlay", onClick: this.props.onClick });
    };
    return FullScreenOverlay;
}(React.Component));
export default FullScreenOverlay;
//# sourceMappingURL=FullScreenOverlay.js.map